import React, { useEffect, useState } from 'react';
import { Button, Chip, Grid, Paper, Stack, Typography } from '@mui/material';
import AuditChecklistApiService from '../api/AuditChecklistApiService';
import StartAuditChecklistModal from './Modal/StartAuditChecklistModal';
import AuditChecklistHistoryModal from './Modal/AuditChecklistHistoryModal';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import HistoryIcon from '@mui/icons-material/History';
import ChecklistIcon from '@mui/icons-material/Checklist';
import { useTranslation } from 'react-i18next';

const auditChecklistApiService = new AuditChecklistApiService();

const AuditChecklists = () => {
    const { t } = useTranslation();
    const [auditChecklists, setAuditChecklists] = useState([]);
    const [selectedAuditChecklist, setSelectedAuditChecklist] = useState({});
    const [openStartChecklistModal, setOpenStartChecklistModal] = useState(false);
    const [openAuditChecklistHistoryModal, setOpenAuditChecklistHistoryModal] = useState(false);

    useEffect(() => {
        auditChecklistApiService.getAuditChecklists().then((auditChecklistResponse) => {
            if (auditChecklistResponse.success) {
                setAuditChecklists(auditChecklistResponse.data);
            }
        });
    }, []);

    function handleHistoryClick(checklist) {
        setSelectedAuditChecklist(checklist);
        setOpenAuditChecklistHistoryModal(true);
    }

    function handleStartClick(checklist) {
        setSelectedAuditChecklist(checklist);
        setOpenStartChecklistModal(true);
    }

    return (
        <div>
            <Typography variant="h4" sx={{ mb: 3 }}>
                {t('auditChecklistsPage.title')}
            </Typography>
            <Grid container spacing={2.5}>
                {auditChecklists.map((checklist, index) => (
                    <Grid key={index} item xs={12} md={6} lg={4}>
                        <Paper
                            elevation={0}
                            variant="outlined"
                            sx={{
                                p: 2.5,
                                borderRadius: 2,
                                transition: 'box-shadow 0.2s ease',
                                '&:hover': {
                                    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                                },
                            }}
                        >
                            <Stack direction="row" alignItems="flex-start" justifyContent="space-between" sx={{ mb: 1 }}>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <ChecklistIcon color="primary" fontSize="small" />
                                    <Typography variant="h6" fontWeight={600}>
                                        {checklist.acTitle}
                                    </Typography>
                                </Stack>
                            </Stack>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                                {checklist.projectName}
                            </Typography>
                            <Chip
                                label={t('auditChecklistsPage.itemsCount', { count: checklist.auditChecklistItems.length })}
                                size="small"
                                variant="outlined"
                                sx={{ mb: 2 }}
                            />
                            <Stack direction="row" spacing={1.5}>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<HistoryIcon />}
                                    onClick={() => handleHistoryClick(checklist)}
                                >
                                    {t('auditChecklistsPage.button.history')}
                                </Button>
                                <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<PlayArrowIcon />}
                                    onClick={() => handleStartClick(checklist)}
                                >
                                    {t('auditChecklistsPage.button.startAudit')}
                                </Button>
                            </Stack>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
            <StartAuditChecklistModal
                open={openStartChecklistModal}
                onCancel={() => {
                    setOpenStartChecklistModal(false);
                }}
                currentAuditChecklist={selectedAuditChecklist}
                onSave={() => {
                    setOpenStartChecklistModal(false);
                }}
            />
            <AuditChecklistHistoryModal
                open={openAuditChecklistHistoryModal}
                onCancel={() => {
                    setOpenAuditChecklistHistoryModal(false);
                }}
                currentSelectedAuditChecklist={selectedAuditChecklist}
            />
        </div>
    );
};

export default AuditChecklists;
